module.exports = __webpack_public_path__ + "static/img/unit_top_bg.4096d74d.png";